import React, { useEffect, useState } from 'react';
import Search from '../searchComponents/Search';
import DatahubAPI from '../../../api/DatahubAPI';
import SubscribeModal from '../../SubscribeModal';
import { Redirect } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';
import PaymentsAPI from 'api/PaymentsAPI';
import { Modal } from '@mui/material';
import CommodityListFilterOptions from '../filterOpts/ComListFilterOpts';
import CommodityCodeFilterOptions from '../filterOpts/ComCodeFilterOpts';
import DateSelector from '../filters/DateSelector';
import format from 'date-fns/format';
import CasesAPI from 'api/CasesAPI';
import { useSnackbar } from 'notistack';
import pako from 'pako';
import { Buffer } from 'buffer';
import { runAIEvaluationSingleProduct } from '../searchComponents/AIEvaluate';
import { includeFields } from 'utils/OSDataHelper';

interface ICommoditiesProps {
  setShowFullRecord: any;
  showFilters: boolean;
  setShowFilters: any;
  cur_user: any;
  activeSub: any;
  userHasCommoditySearch: boolean;
  matchedTeamWithStripe: any;
  inputs: any;
  setInputs: any;
  page: number;
  setPage: any;
  commodityState: any;
  setCommodityState: any;
  listFilters: any;
  setListFilters: any;
  codeFilters: any;
  setCodeFilters: any;
  screeningCus: any;
}

const Commodities: React.FC<ICommoditiesProps> = ({ screeningCus, commodityState, setCommodityState, inputs, setInputs, page, setPage, activeSub, userHasCommoditySearch, matchedTeamWithStripe, cur_user, setShowFullRecord, listFilters, setListFilters, codeFilters, setCodeFilters }) => {
  const [ commodityReturns, setCommodityReturns ] = useState<any>({ isLoading: true, data: [] });
  const [ initialComplete, setInitialComplete ] = useState(false);
  const [ submit, setSubmit ] = useState<any>({
    trigger: false,
    reason: ''
  });
  const [ commodityFiltersTotal, setCommodityFiltersTotal ] = useState<any>({ isLoading: true, data: 0 });
  const [ filterModeList, setFilterModeList ] = useState<boolean>(false);
  const [ filterModeCode, setFilterModeCode ] = useState<boolean>(false);
  const [ appliedListFilter, setAppliedListFilter ] = useState<any>({});
  const [ appliedCodeFilter, setAppliedCodeFilter ] = useState<any>({});
  const [ openDate, setOpenDate ] = useState(false);
  const [ saving, setSaving ] = useState(false);
  const [ aiSums, setAiSums ] = useState<any>([]);

  const { enqueueSnackbar } = useSnackbar();
  const dt = new Date();
  const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  // HS CODE FILTERS

  const [ lensOpts, setLensOpts ] = useState<{
      isLoading: boolean;
      data: any;
    }>({ isLoading: true, data: [] });
  const [ hsCodeListOpts, setHsCodeListOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ sectionOpts, setSectionOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: false, data: [] });
  const [ chapterOpts, setChapterOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: false, data: [] });
  const [ codeOpts, setCodeOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: false, data: [] });

  // DATA FILTERS
  const [ countryOpts, setCountryOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ agencyOpts, setAgencyOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [ listOpts, setListOpts ] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });

  const [ countOpts, setCountOpts ] = useState([]);
  const [ agOpts, setAgOpts ] = useState([]);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleClear = () => {
    setCommodityState({
      fuzzy: false,
      date: null,
      dateArr: [],
      comLenses: [],
      agencies: [],
      countries: [],
      lists: [],
      sections: [],
      chapters: [],
      codes: [],
      hsCodeLists: [],
    });
    setSectionOpts({ isLoading: false, data: [] });
    setChapterOpts({ isLoading: false, data: [] });
    setCodeOpts({ isLoading: false, data: [] });
    setSubmit({ reason: 'apply', trigger: !submit.trigger });
    setAppliedListFilter({});
    setAppliedCodeFilter({});
  };

  const handleListClear = () => {
    setCommodityState({
      ...commodityState,
      comLenses: [],
      agencies: [],
      countries: [],
      lists: [],
    });
    setAppliedListFilter({});
    setSubmit({ reason: 'apply', trigger: !submit.trigger });
  };


  const handleHSClear = () => {
    setCommodityState({
      ...commodityState,
      sections: [],
      chapters: [],
      codes: [],
      hsCodeLists: [],
    });
    setSectionOpts({ isLoading: false, data: [] });
    setChapterOpts({ isLoading: false, data: [] });
    setCodeOpts({ isLoading: false, data: [] });
    setAppliedCodeFilter({});
    setSubmit({ reason: 'apply', trigger: !submit.trigger });
  };

  const handleDateChange = (newValue: any) => {
    const arr: any = [ ...newValue ];
    if (newValue !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
      setCommodityState({ ...commodityState, date: newValue, dateRange: arr });
    } else {
      setCommodityState({ ...commodityState, date: null, dateRange: [] });
    }
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCommodityState({ ...commodityState, fuzzy: event.target.checked });
  };

  const handleTicket = async(values: any) => {
    const new_case = {
      groupId: cur_user.selected_team.id,
      ...values.basics,
      ...values,
    };
    const resp = await CasesAPI.createCase({ newCase: new_case });
    if (resp?.success) {
      setSaving(false);
      enqueueSnackbar('Successfully created new case', { variant: 'success' });
    } else if (resp) {
      const error_msg = 'Error saving new case. Uploaded file(s) may be too large.';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const compressData = (data: any) => {
    const stringifiedData = JSON.stringify(data);
    const compressed = pako.gzip(stringifiedData);
    return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
  };

  const createTicket = async(name: string) => {
    setSaving(true);
    const comFilterQuery = {
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      hsCodeLists: commodityState.hsCodeLists,
      sections: commodityState.sections,
      chapters: commodityState.chapters,
      codes: commodityState.codes,
      entRes: commodityState.fuzzy,
      filterDate: commodityState.dateRange
    };

    const entFilterQuery = {
      lenses: [],
      countries: [],
      agencies: [],
      lists: [],
      entRes: false,
      filterDate: []
    };

    const ownerQuery = {
      kc_id: cur_user.basics?.id,
      email: cur_user.basics?.email,
      firstName: cur_user.basics?.firstName,
      lastName: cur_user.basics?.lastName,
    };

    const query: any = {
      ticketName: name,
      lastUpdate: formatted_dt,
      commodity: {
        harmonizedScheduleCode: inputs.hsCode,
        commodityName: inputs.desc,
        countryOfOrigin: inputs.origin,
        destinationCountry: inputs.destination
      },
      docType: 'Single Entry - Products',
      commodityFilter: comFilterQuery,
      entityFilter: entFilterQuery,
      frequency: 'Once',
      sharedWith: [],
      activeFilter: '',
      selectedOpts: [],
      status: 'Complete',
      favorite: false,
      groupName: cur_user.selected_team.name,
      template: [],
      colMapping: [],
      activity: {
        user: {
          kc_id: cur_user.basics?.id,
          email: cur_user.basics?.email,
          firstName: cur_user.basics?.firstName,
          lastName: cur_user.basics?.lastName,
        },
        action:  'created monitor ticket',
        timeStamp: Date.now()
      },
      owner: ownerQuery
    };
    const extractSources = (docs: any): any[] => {
      return docs.map((doc: any) => doc._source);
    };
    const length = commodityReturns.data[0].result.body.hits.total.value;
    const structuredObj = [ {
      dataSet: 'Commodities',
      docs: extractSources(commodityReturns.data[0].result.body.hits.hits),
      field: inputs.hsCode.length > 0 ? inputs.hsCode : inputs.desc,
      hits: length,
      row: 1
    } ];


    const ticketQuery = {
      ...query,
      curTotal: length,
      curNew: 0,
      results: {
        allResults: compressData(structuredObj),
        allTotal: length,
        newResults: [],
        newTotal: 0,
        date: formatted_dt,
        docInfo: []
      },
    };
    handleTicket(ticketQuery);
  };

  const getComCSVResults = async(pageNum: number) => {
    const allResults: any = [];

    let val = '';
    const format = (str:string, n: number) => {
      const ret: string[] = [];
      let i;
      let len;

      for(i = 0, len = str.length; i < len; i = i + n) {
        if (i === 0) {
          ret.push(str.substr(i, n + 2));
        } else if (i > 2) {
          ret.push(str.substr(i, n));
        }
      }
      return ret;
    };
    const re = new RegExp('^[0-9]+$');
    if (re.test(inputs.hsCode)) {
      val = format(inputs.hsCode, 2).join('.');
    }
    const query = {
      primary: val.length > 0 ? val : inputs.desc,
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.countries.length > 0 ||
        commodityState.agencies.length > 0 ||
        commodityState.lists.length > 0 ?
        [] : commodityState.lenses,
      listCountry: commodityState.agencies.length > 0 || commodityState.lists.length > 0 ? [] : commodityState.countries,
      agency: commodityState.lists.length > 0 ? [] : commodityState.agencies,
      listName: [ ...commodityState.lists, ...commodityState.hsCodeLists ],
      hsCodeSection: commodityState.sections,
      hsCodeChapter: commodityState.chapters,
      hsCode: commodityState.codes,
      dateRange: commodityState.dateRange,
      agg: false,
      pageNum: pageNum,
      fuzziness: commodityState.fuzzy ? 'AUTO' : 0,
      qty: 200
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
    }

    return allResults;
  };

  // GET INITIAL RESULTS AND SET OPTIONS
  const initialAPICall = async() => {
    const tableQuery: any = {
      indices: [ 'bite_app_commodities_*' ],
      agg: false,
    };

    const tableRes = await DatahubAPI.commoditySearch(tableQuery);

    // RETURNS AND TOTAL CALCULATION
    setCommodityFiltersTotal({ isLoading: false, data: tableRes?.result?.result?.body?.hits?.total?.value });
    setCommodityReturns({ isLoading: false, data: [ tableRes?.result ] });

    const filtersAggQuery: any = {
      indices: [ 'bite_app_commodities_*' ],
      agg: true,
    };
    const hsAggQuery: any = {
      indices: [ 'bite_app_commodities_nomenclature' ],
      agg: true
    };

    const filtersAggRes = await DatahubAPI.commoditySearch(filtersAggQuery);
    const hsAggRes = await DatahubAPI.commoditySearch(hsAggQuery);
    if (filtersAggRes?.success) {
      // LISTING FILTERS
      setLensOpts({ isLoading: false, data: [ ...filtersAggRes?.result.result.body.aggregations.listAgg.buckets ] });
      const countryBuckets: any = [];
      filtersAggRes?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        countryBuckets.push(bucket.countryAgg.buckets);
      });

      setCountryOpts({ isLoading: false, data: countryBuckets.flat() });
      const agencyBuckets: any = [];
      filtersAggRes.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          agencyBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });

      setAgencyOpts({ isLoading: false, data: agencyBuckets.flat() });
      const listBuckets: any = [];
      filtersAggRes.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            listBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });

      setListOpts({ isLoading: false, data: listBuckets.flat() });

      setHsCodeListOpts({ isLoading: false, data: hsAggRes?.result.result.body.aggregations.listName.buckets });
      if (commodityState.comLenses.length > 0) {
        setInitialComplete(true);
      }
    }
  };

  // HNDLE LENS CHANGE
  const handleLensChange = async() => {
    setLensOpts({ ...lensOpts, isLoading: true });
    setCountryOpts({ ...countryOpts, isLoading: true });
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.comLenses.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        addedBuckets.push(bucket.countryAgg.buckets);
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });

      setCommodityState({
        ...commodityState,
        countries: selections
      });
      setCountOpts(selections);
    } else if (commodityState.comLenses.length === 0) {
      setCountOpts([]);
      setCommodityState({
        ...commodityState,
        countries: [],
        agencies: [],
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Country Regulator'
    });
  };

  // HANDLE COUNTRY CHANGE
  const handleCountryChange = async() => {
    setAgencyOpts({ ...agencyOpts, isLoading: true });
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listCountry: commodityState.countries,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.countries.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          addedBuckets.push(secondBucket.agencyAgg.buckets);
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setCommodityState({
        ...commodityState,
        agencies: selections
      });
      setAgOpts(selections);
    } else if (commodityState.countries.length === 0) {
      setCommodityState({
        ...commodityState,
        agencies: [],
        lists: [],
      });
      setAgOpts([]);
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'Agency'
    });
    setCountryOpts({ ...countryOpts, isLoading: false });
  };

  // HANDLE AGENCY CHANGE
  const handleAgencyChange = async() => {
    setListOpts({ ...listOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      agency: commodityState.agencies,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.agencies.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.listAgg?.buckets.map((bucket: any) => {
        bucket.countryAgg.buckets.map((secondBucket: any) => {
          secondBucket.agencyAgg.buckets.map((thirdBucket: any) => {
            addedBuckets.push(thirdBucket.listNameAgg.buckets);
          });
        });
      });
      const selections = addedBuckets.flat().map((obj: any) => {
        return obj.key;
      });
      setCommodityState({
        ...commodityState,
        lists: selections
      });
    } else if (commodityState.agencies.length === 0) {
      setCommodityState({
        ...commodityState,
        lists: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'List'
    });
    setAgencyOpts({ ...agencyOpts, isLoading: false });
  };

  // HANDLE LIST CHANGE
  const handleListChange = async() => {
    const query: any = {
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listName: commodityState.lists,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success) {
      setCommodityFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }
    setListOpts({ ...listOpts, isLoading: false });
  };


  // HNDLE HS CODE LIST CHANGE
  const handleHsCodeListChange = async() => {
    setSectionOpts({ ...sectionOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_nomenclature' ],
      listName: commodityState.hsCodeLists,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.hsCodeLists.length) {
      setSectionOpts({ isLoading: false, data: res?.result.result.body.aggregations.hsAgg.buckets });
      if (commodityState.sections.length) {
        handleSectionChange();
      }
    } else {
      setCodeOpts({ isLoading: false, data: [] });
      setChapterOpts({ isLoading: false, data: [] });
      setSectionOpts({ isLoading: false, data: [] });
    }
  };

  // HANDLE SECTION CHANGE
  const handleSectionChange = async() => {
    setChapterOpts({ ...chapterOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_nomenclature' ],
      hsCodeSection: commodityState.sections,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.sections.length > 0) {
      const chapterBuckets: any = [];
      res?.result?.result?.body?.aggregations?.hsAgg?.buckets.map((bucket: any) => {
        chapterBuckets.push(bucket.chapterAgg.buckets);
      });
      setChapterOpts({ isLoading: false, data: chapterBuckets.flat() });
      if (commodityState.chapters.length) {
        handleChapterChange();
      }
    } else if (commodityState.sections.length === 0) {
      setCommodityState({
        ...commodityState,
        chapters: [],
        codes: [],
      });
      setCodeOpts({ isLoading: false, data: [] });
      setChapterOpts({ isLoading: false, data: [] });
    }
  };

  // HANDLE CHAPTER CHANGE
  const handleChapterChange = async() => {
    setCodeOpts({ ...codeOpts, isLoading: true });
    const query: any = {
      indices: [ 'bite_app_commodities_nomenclature' ],
      hsCodeChapter: commodityState.chapters,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success && commodityState.chapters.length > 0) {
      const addedBuckets: any = [];
      res?.result?.result?.body?.aggregations?.hsAgg?.buckets.map((bucket: any) => {
        bucket.chapterAgg.buckets.map((secondBucket: any) => {
          addedBuckets.push(secondBucket.codeAgg.buckets);
        });
      });
      setCodeOpts({ isLoading: false, data: addedBuckets.flat() });
    } else if (commodityState.chapters.length === 0) {
      setCodeOpts({ isLoading: false, data: [] });
      setCommodityState({
        ...commodityState,
        codes: [],
      });
    }
    setSubmit({
      trigger: !submit.trigger,
      reason: 'HS Code'
    });
  };

  // HANDLE CODE CHANGE
  const handleCodeChange = async() => {
    const query: any = {
      indices: [ 'bite_app_commodities_nomenclature' ],
      hsCode: commodityState.codes,
      updateDay: commodityState.dateArr,
      agg: true,
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success) {
      setCommodityFiltersTotal({ isLoading: false, data: res?.result?.result?.body?.hits?.total?.value });
    }
  };

  const triggerMeter = async(): Promise<any> => {
    const res = await PaymentsAPI.updateMeter(
      {
        type: 'screening_products_meter'
      },
      screeningCus.data.id
    );
    if (res?.success) {
      return res?.result;
    }
  };

  const handleSubmit = async(pageNum: number) => {
    if (inputs.hsCode.length === 0 && inputs.desc.length === 0) {
      enqueueSnackbar('Please enter an HTS Code or product description to screen.', { variant: 'error' });
      return;
    }

    const formatHTS = (input: string): string => {
      if (input.length === 0) {
        return '';
      }
      // Remove all non-digit characters
      const digitsOnly = input.replace(/\D/g, '');

      // Split into groups: 4, 2, 2, 2
      const parts = [];
      if (digitsOnly.length !== 6 && digitsOnly.length !== 8 && digitsOnly.length !== 10) {
        const error_msg = 'Please enter a valid HTS Code that is 6, 8 or 10 digits.';
        enqueueSnackbar(error_msg, { variant: 'error' });
        return 'error';
      }

      if (digitsOnly.length >= 4) {
        parts.push(digitsOnly.slice(0, 4));
      }
      if (digitsOnly.length >= 6) {
        parts.push(digitsOnly.slice(4, 6));
      }
      if (digitsOnly.length >= 8) {
        parts.push(digitsOnly.slice(6, 8));
      }
      if (digitsOnly.length === 10) {
        parts.push(digitsOnly.slice(8, 10));
      }

      return parts.join('.');
    };

    const val = formatHTS(inputs.hsCode);
    if (val === 'error') {
      return;
    }
    setCommodityReturns({ isLoading: true, data: [] });
    setAiSums([]);
    const allResults: any = [];
    let total = 0;
    const aiSummaries: any = [];

    const query = {
      primary: val.length > 0 ? val : inputs.desc,
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listCountry:
            commodityState.agencies.length > 0 || commodityState.lists.length > 0 ?
              [] : commodityState.countries,
      agency: commodityState.lists.length > 0 ?
        [] : commodityState.agencies,
      listName: [ ...commodityState.lists, ...commodityState.hsCodeLists ],
      hsCodeSection:
            commodityState.codes.length > 0 || commodityState.chapters > 0 ? [] : commodityState.sections,
      hsCodeChapter: commodityState.codes.length > 0 ? [] : commodityState.chapters,
      hsCode: commodityState.codes,
      dateRange: commodityState.dateRange,
      agg: true,
      pageNum: pageNum
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success) {
      allResults.push(res?.result);
      total = total + res?.result?.result?.body?.hits?.total?.value;


//       if (inputs.hsCode.length > 0) {
//         const fields = [
//           'HS Code',
//           'BITE-Identified Risk Country',
//           'List Name',
//           'Trade Type',
//         ];
//         const hits = res?.result?.result?.body?.hits?.hits;

//         if (inputs.origin.length < 1 || inputs.destination.length < 1) {
//           const ai_summary = {
//             hs_code: '',
//             explanation: 'Please fill out all fields labeled as Required for AI in order to get an AI Evaluation on your screen',
//             trade_category: '',
//             risk_level: ''
//           };
//           aiSummaries.push(ai_summary);
//         } else if (hits.length > 1000) {
//           const ai_summary = {
//             hs_code: inputs.hsCode,
//             explanation: 'Your searched returned over 1,000 results. Please narrow down your search by adjusting your filters or providing a more specific value if you would like an Evaluation.',
//             trade_category: '',
//             risk_level: ''
//           };
//           aiSummaries.push(ai_summary);
//         } else {
//           const hit_list = hits.map((hit: any) => hit._source);
//           // Run the AI evaluation on the hits
//           const filtered = await includeFields(fields, hit_list);
//           const ai_summary = await runAIEvaluationSingleProduct(
//             inputs.hsCode,
//             inputs.origin,
//             inputs.destination,
//             JSON.stringify(filtered),
//           );
//           aiSummaries.push(ai_summary);
//         }
//       } else {
//         const ai_summary = {
//           hs_code: '',
//           explanation: 'Please fill out all fields labeled as Required for AI in order to get an AI Evaluation on your screen',
//           trade_category: '',
//           risk_level: ''
//         };
//         aiSummaries.push(ai_summary);
//       }


      if (inputs.primary !== '') {
        triggerMeter();
      }
    }

    setCommodityReturns({ isLoading: false, data: allResults });
    setAiSums(aiSummaries);
    if (commodityState.comLenses.length === 0 &&
        commodityState.countries.length === 0 &&
        commodityState.agencies.length === 0 &&
        commodityState.lists.length === 0 &&
        commodityState.hsCodeLists.length === 0 &&
        commodityState.sections.length === 0 &&
        commodityState.chapters.length === 0 &&
        commodityState.codes.length === 0
    ) {
      setCommodityFiltersTotal({ isLoading: false, data: total });
    }
  };

  const handleMultiPageChange = async(input: any, pageNum: number, i: number) => {
    const allResults: any = commodityReturns.data;
    const query = {
      primary: input,
      indices: [ 'bite_app_commodities_*' ],
      lens: commodityState.comLenses,
      listCountry:
        commodityState.agencies.length > 0 || commodityState.lists.length > 0 ?
          [] : commodityState.countries,
      agency: commodityState.lists.length > 0 ?
        [] : commodityState.agencies,
      listName: [ ...commodityState.lists, ...commodityState.hsCodeLists ],
      hsCodeSection:
        commodityState.codes.length > 0 || commodityState.chapters > 0 ? [] : commodityState.sections,
      hsCodeChapter: commodityState.codes.length > 0 ? [] : commodityState.chapters,
      hsCode: commodityState.codes,
      dateRange: commodityState.dateRange,
      agg: true,
      pageNum: pageNum
    };
    const res = await DatahubAPI.commoditySearch(query);
    if (res?.success) {
      allResults[i] = res?.result;
    }
    setCommodityReturns({ isLoading: false, data: allResults });
  };

  useEffect(() => {
    switch (submit.reason) {
    case 'Lens':
      handleLensChange();
      break;
    case 'Country Regulator':
      handleCountryChange();
      break;
    case 'Agency':
      handleAgencyChange();
      break;
    case 'List':
      handleListChange();
      break;
    case 'HS Code List':
      handleHsCodeListChange();
      break;
    case 'Section':
      handleSectionChange();
      break;
    case 'Chapter':
      handleChapterChange();
      break;
    case 'HS Code':
      handleCodeChange();
      break;
    case 'apply':
      handleSubmit(page);
      break;
    default:
      initialAPICall();
    }
  }, [ submit ]);

  useEffect(() => {
    if (initialComplete) {
      handleLensChange();
      handleSubmit(page);
    }
  }, [ initialComplete ]);

  useEffect(() => {
    setPage(0);
  }, [ inputs ]);

  return (
    <div className='screening-body-container'>
      {activeSub === 'BITE Pro' ||
      activeSub === 'BITE Enterprise' &&
      !userHasCommoditySearch ? (
          <div className='no-license-modal-screening'>
            <Player
              autoplay
              loop
              src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
              style={{ width: '20%' }}
            >
            </Player>
            <Typography variant='h6' className='text-white'
              style={{
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0.15px'
              }}
            >
            You need an assigned license to access this module
            </Typography>
            <Typography variant='h6'
              style={{
                fontSize: '8px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0.15px',
                marginTop: '20px',
                color: '#BDBEC1'
              }}
            >
            Visit Account &gt; Users &gt; to assign
            an available license to your user or contact your team admin
            </Typography>
          </div>
        ) : (
          !userHasCommoditySearch ? (
            <SubscribeModal
              name='Screening'
              screening={true}
              description='Quickly search for high risk people, companies and products as well as cyber threat indicators.'
              price={25}
              curUser={cur_user}
              stripeTeam={matchedTeamWithStripe}
              activeSub={activeSub}
            />
          ) : <></>
        )}
      <Search
        cyberTab={undefined}
        handleTabSwitch={undefined}
        userHasSearch={userHasCommoditySearch}
        setShowFullRecord={setShowFullRecord}
        type={'Products'}
        handleSubmit={handleSubmit}
        inputs={inputs}
        setInputs={setInputs}
        results={commodityReturns}
        page={page}
        setPage={setPage}
        cyberHeaders={[]}
        getCSVResults={getComCSVResults}
        handleMultiPageChange={handleMultiPageChange}
        state={commodityState}
        openFilters={() => setFilterModeList(true)}
        openFiltersCode={() => setFilterModeCode(true)}
        handleClear={handleClear}
        handleOpenDate={() => setOpenDate(true)}
        handleSwitchChange={handleSwitchChange}
        createTicket={createTicket}
        saving={saving}
        aiSums={aiSums}
      />
      <Modal
        open={filterModeList}
        onClose={() => setFilterModeList(false)}
        sx={{ zIndex: 900 }}
      >
        <CommodityListFilterOptions
          inputs={inputs}
          totalRecords={commodityFiltersTotal.data}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          setFilterMode={setFilterModeList}
          lensOpts={lensOpts}
          countryOpts={countryOpts}
          agencyOpts={agencyOpts}
          listOpts={listOpts}
          setSubmit={setSubmit}
          submit={submit}
          handleClear={handleListClear}
          appliedFilter={appliedListFilter}
          setAppliedFilter={setAppliedListFilter}
          countOpts={countOpts}
          agOpts={agOpts}
          filters={listFilters}
          setFilters={setListFilters}
          cur_user={cur_user}
        />
      </Modal>
      <Modal
        open={filterModeCode}
        onClose={() => setFilterModeCode(false)}
        sx={{ zIndex: 900 }}
      >
        <CommodityCodeFilterOptions
          inputs={inputs}
          totalRecords={commodityFiltersTotal.data}
          setFilterMode={setFilterModeCode}
          hsCodeListOpts={hsCodeListOpts}
          chapterOpts={chapterOpts}
          sectionOpts={sectionOpts}
          codeOpts={codeOpts}
          setSubmit={setSubmit}
          submit={submit}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          handleClear={handleHSClear}
          appliedFilter={appliedCodeFilter}
          setAppliedFilter={setAppliedCodeFilter}
          filters={codeFilters}
          setFilters={setCodeFilters}
          cur_user={cur_user}
        />
      </Modal>
      <Modal
        open={openDate}
        onClose={() => setOpenDate(false)}
      >
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={commodityState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </div>
  );
};

export default Commodities;
